import { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { AnimatePresence, MotionConfig, motion } from 'framer-motion';
import { pageVariants } from '@/shared/motion/motionPresets';
import { ConciergeHandoff } from '../components/ConciergeHandoff';
import { NavigatorChat } from './components/NavigatorChat';
import { CareGuideLoadingPage } from './components/CareGuideLoadingPage';
import { CareSeekerResults } from './components/CareSeekerResults';
import { NavigatorHub } from './components/NavigatorHub';
import { SharedCarePlanView } from './components/SharedCarePlanView';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.history.scrollRestoration = 'manual';
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

export const CareNavigatorPage = () => {
  const location = useLocation();

  return (
    // reducedMotion="user" lets framer-motion drop transform animations for
    // users with a reduced-motion preference across the whole navigator flow.
    <MotionConfig reducedMotion="user">
      <ScrollToTop />
      <AnimatePresence mode="wait" initial={false}>
        <motion.div
          key={location.pathname}
          variants={pageVariants}
          initial="initial"
          animate="animate"
          exit="exit"
        >
          {/* Routes reads the pinned location so the exiting page keeps
              rendering its own route during the exit transition. */}
          <Routes location={location}>
            <Route index element={<NavigatorChat />} />
            <Route path="generating" element={<CareGuideLoadingPage />} />
            <Route path="results" element={<CareSeekerResults />} />
            <Route path="shared/:engagementId" element={<SharedCarePlanView />} />
            <Route path="concierge" element={<ConciergeHandoff />} />
            <Route path="dashboard" element={<NavigatorHub />} />
            <Route path="*" element={<Navigate to="/404" replace />} />
          </Routes>
        </motion.div>
      </AnimatePresence>
    </MotionConfig>
  );
};
